/* raw layout hash: _property-location-registry-layout:3b0909d8fd212d03d3c6318aaf3887356d57c49ebf745e048a3e5ba8217ed9a6 */
import React from "react";
import AppShell from "./AppShell.jsx";

// Layout "_property-location-registry-layout" (RawHTMLDesign/layouts/_property-location-registry-layout.html)
export default function PropertyLocationRegistryLayout({ children }) {
  return <AppShell menuKey="full">{children}</AppShell>;
}
